import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './styles/App.css';
import LoginPage from './components/LoginPage';
import MainPage from './components/MainPage';
import UsersService, { BOAPI } from './service/UsersService';
import UserDetails from './components/UserDetails';

export default function BackOfficeApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState('');
  const [currentUserRole, setCurrentUserRole] = useState('');

  useEffect(() => {
    const savedUser = localStorage.getItem('currentUser');
    const savedRole = localStorage.getItem('currentUserRole');

    if (savedUser) {
      setCurrentUser(savedUser);
      setCurrentUserRole(savedRole || '');
      setIsLoggedIn(true);
    }

    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'he';
  }, []);

  const handleLogin = (username, role) => {
    setCurrentUser(username);
    setCurrentUserRole(role || '');
    setIsLoggedIn(true);
    localStorage.setItem('currentUser', username);
    localStorage.setItem('currentUserRole', role || '');
  };

  const handleLogout = () => {
    BOAPI.logout().catch(() => {});
    UsersService.clear();
    setIsLoggedIn(false);
    setCurrentUser('');
    setCurrentUserRole('');
    sessionStorage.clear();
    localStorage.clear();
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Login */}
        <Route
          path="/login"
          element={
            isLoggedIn
              ? <Navigate to="/" />
              : <LoginPage onLogin={handleLogin} />
          }
        />

        {/* פרטי משתמש - עמוד עצמאי (כותרת/כפתור חזרה משלו), לא מוצג בתוך
            מעטפת MainPage - נשמר כנתיב נפרד אבל עדיין דורש התחברות כמו הכל */}
        <Route
          path="/users/:id"
          element={
            isLoggedIn
              ? <UserDetails />
              : <Navigate to="/login" />
          }
        />

        {/* App - כל שאר הנתיבים (כולל /) */}
        <Route
          path="/*"
          element={
            isLoggedIn
              ? <MainPage currentUser={currentUser} currentUserRole={currentUserRole} onLogout={handleLogout} />
              : <Navigate to="/login" />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
